import styles from "./FlixMedia.module.scss";
import { LoadingSpinner } from "@JohnLewisPartnership/jl-design-system/dist/components/loading-spinner/LoadingSpinner";
import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { PlusOutlined as Plus24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/PlusOutlined";
import { MinusOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/MinusOutlined";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type Props = {
  /**
   * A boolean indicating whether the component is loading.
   */
  isLoading: boolean;
  /**
   * A boolean indicating whether the component is open.
   */
  isOpen: boolean;
  /**
   * A function that handles the toggle event.
   */
  handleToggle: () => void;
  /**
   * A reference to the FlixMedia container div element.
   */
  flixMediaContainerRef: React.RefObject<HTMLDivElement | null>;
  /**
   * A reference to the FlixMedia inpage div element.
   */
  flixMediaInpageRef: React.RefObject<HTMLDivElement | null>;
};

export const FlixMediaUI = ({
  isLoading,
  isOpen,
  handleToggle,
  flixMediaContainerRef,
  flixMediaInpageRef,
}: Props) => {
  const Minus24PxOutlinedInverted = () => (
    <MinusOutlined className={styles.toggleIcon} size="medium" />
  );

  const Plus24PxOutlinedIconInverted = () => (
    <Plus24PxOutlinedIcon className={styles.toggleIcon} size="medium" />
  );

  return (
    <div
      ref={flixMediaContainerRef}
      className={styles.wrapper}
      data-testid="flix-media-wrapper"
      data-component="FlixMedia"
    >
      {isLoading && <LoadingSpinner />}
      <div
        data-testid="flix-media-inpage-container"
        className={cx(styles.inpageContainer, {
          revealed: isOpen,
          hidden: isLoading,
        })}
      >
        <div className={styles.header}>
          <h2 className={styles.title}>Take a closer look</h2>
          Information from the brand
        </div>

        <div id="flix-react-inpage" ref={flixMediaInpageRef} />
      </div>
      <div
        className={cx(styles.footer, {
          hidden: isLoading,
          revealedFooter: isOpen,
        })}
        data-testid="flix-media-footer"
      >
        <TertiaryButton
          className={styles.toggleButton}
          data-testid="flix-media-footer-button"
          onClick={handleToggle}
          small={true}
          variant="filled-dark"
          IconComponent={
            isOpen ? (
              <Minus24PxOutlinedInverted />
            ) : (
              <Plus24PxOutlinedIconInverted />
            )
          }
          iconPositionRight
        >
          <span className={styles.toggleText}>
            {isOpen ? "Show less" : "Show more"}
          </span>
        </TertiaryButton>
      </div>
    </div>
  );
};
